/**
 *
 * @author: Matthew Rawson @ 15/08/2018 12:20
 * @description:
 * @notes
 * - Allow footer content to be styled separately for each step (footer content layout will change for each step).
 * - `PageWithStickyFooter` sets the footer height to be 85px with no overflow.
 *   Height: 100%; needs to be set here to make use of all the space available.
 * - Needs a pseudo element to balance the footer content positioning
 */
import styled from "styled-components"

export default styled.div`
  display: flex;
  flex: 1;
  justify-content: ${({pullRight}) => (pullRight ? "flex-end" : "space-between")};
  align-items: center;
  height: 100%;
  
  ${({fakeFirstElement}) => fakeFirstElement && `
    justify-content: space-evenly;
      &:before {
        content: "";
        flex:1
      }
  `}
`
